import React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"

const CalloutBox = ({
  kicker,
  title,
  description,
  link,
  image,
  imageAlt,
  rightContent,
  children,
  className = "",
}) => {
  const hasRightContent = image ?? rightContent

  return (
    <section className={`container-fluid row center-xs ${className}`}>
      <div className="callout-box callout-box--row">
        <div className="callout-box__left">
          <div className="callout-box__content">
            {children ?? (
              <>
                {kicker && (
                  <span className="callout-box__kicker">{kicker}</span>
                )}
                {title && <h3>{title}</h3>}
                {description && <p className="p--lg">{description}</p>}
                {link?.to && link?.text && (
                  <Link className="btn btn--primary mt-10" to={link.to}>
                    {link.text}
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
        {hasRightContent && (
          <>
            <hr className="divider divider--vertical-dashed callout-box__divider" />
            <div
              className={`callout-box__right ${
                image ? "callout-box__right--grow" : ""
              }`}
            >
              {image ? (
                <GatsbyImage image={image} alt={imageAlt ?? ""} />
              ) : (
                rightContent
              )}
            </div>
          </>
        )}
      </div>
    </section>
  )
}

export default CalloutBox
